"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = void 0;
class Events {
    static _subscriptions = new Map();
    static on(event, callback, context) {
        const subscriptions = this._subscriptions.get(event);
        const bind = callback.bind(context);
        this._subscriptions.set(event, subscriptions ? [...subscriptions, bind] : [bind]);
    }
    static emit(event, data) {
        for (const subscription of this._subscriptions.get(event) ?? []) {
            subscription(data);
        }
    }
    static removeListener(event, callback, context) {
        const subscriptions = this._subscriptions.get(event);
        const bind = callback.bind(context);
        this._subscriptions.set(event, subscriptions?.filter((s) => s.toString() !== bind.toString()) ?? []);
    }
}
exports.Events = Events;
